import React, { useEffect, useState } from 'react';
import { Layout, Grid } from 'antd';
import Path, { LayoutType } from 'routes';
import { isEmpty } from 'utils/utils';
import { BisectionHeader, BisectionFooter } from './bisection';
import { Error404 } from 'components/pages';

export interface DefaultLayoutProps {}

const DefaultLayout = ({ children }: React.PropsWithChildren<DefaultLayoutProps>): React.ReactElement => {
  if (Path.is404Page(window.location.pathname)) {
    return <Error404 />;
  }

  /* ======================================================
   * variables
   * ====================================================== */
  const layout: LayoutType = Path.getProperty(window.location.pathname, 'layout');
  const width = Grid.useBreakpoint();

  /* ======================================================
   * states
   * ====================================================== */

  /* ======================================================
   * effects
   * ====================================================== */

  /* ======================================================
   * events
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  switch (layout) {
    case 'bisection':
      return (
        <Layout>
          <BisectionHeader />
          <Layout.Content className="layoutContent">{children}</Layout.Content>
          <BisectionFooter />
        </Layout>
      );
    default:
      return <>{children}</>;
  }
};

export default DefaultLayout;
